import CustomTextField from "../../../DriverPopUp/common/CustomTextField";
import { withStyles } from "@material-ui/core";
import WithRowLabel from "./WithRowLabel";

const styles = (theme) => ({
  inputField: {
    padding: 0,
    height: 32,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    paddingLeft: 8,
    paddingRight: 8,
  },
  inputRoot: {
    "& $notchedOutline,$inputMultiline": {
      padding: 0,
      height: "auto",
    },
    "&$inputDisabled": {
      // padding: 8,
    },
  },
  inputDisabled: {},
  inputMultiline: {},
});

const StyledTextField = withStyles(styles)(CustomTextField);
const TextFieldWithLabel = WithRowLabel(StyledTextField);
export { StyledTextField, TextFieldWithLabel };
